import type { ReactNode } from 'react';
import { useMediaMatch } from 'rooks';

export type MatchMediaProps = {
  query: string;
  children: ReactNode;
};

/**
 * Media Match Wrapper Component
 *
 * Component wrapper for useMediaMatch allowing for
 * child to be conditionally loaded by media query. SSR only.
 *
 * @param query - string
 * @param children - ReactNode
 * @constructor
 */
export const MediaMatch = ({ query, children }: MatchMediaProps) => {
  if (typeof window === 'undefined') return null;

  return <MediaMatchEffect query={query}>{children}</MediaMatchEffect>;
};

const MediaMatchEffect = ({ query, children }: MatchMediaProps) => {
  const match = useMediaMatch(query);

  if (!match) return null;

  return <>{children}</>;
};
